import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const RecommendedTopicCard = ({ topic, onOpen }) => (
  <div className="flex h-full flex-col rounded-lg border border-slate-200 bg-white p-5 shadow-sm transition-colors hover:border-blue-200">
    <div className="mb-3 flex items-center justify-between gap-3">
      <span className="rounded bg-blue-50 px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest text-blue-700">
        {topic.context_label || topic.content_category}
      </span>
      <SafeIcon icon={FiIcons.FiBookOpen} className="h-4 w-4 text-blue-500" />
    </div>
    <h3 className="font-bold text-slate-900">{topic.title}</h3>
    <p className="mt-2 flex-1 text-xs leading-relaxed text-slate-500">
      {topic.short_summary || topic.plain_english_explanation}
    </p>
    {topic.reason && (
      <p className="mt-4 border-t border-slate-100 pt-3 text-[10px] font-semibold italic leading-relaxed text-blue-600">
        "{topic.reason}"
      </p>
    )}
    <button
      type="button"
      onClick={() => onOpen(topic)}
      className="mt-4 inline-flex items-center justify-center rounded bg-slate-50 py-2 text-xs font-bold uppercase tracking-widest text-slate-700 transition-colors hover:bg-slate-100"
    >
      Learn More
      <SafeIcon icon={FiIcons.FiArrowRight} className="ml-1.5 h-3.5 w-3.5" />
    </button>
  </div>
);

export default RecommendedTopicCard;
